import { GSButton, GSInfoGroup } from "golfstatus_react_components";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { getRouting } from "../../helpers/Converters";
import { eventBaseRoute } from "../../routes/event";
import { useTournament } from "../../hooks/tournamentHooks";
import { useGolfstatusNavigate } from "../../hooks/navigationHooks";

const RegisterNowWidget = (props) => {
  const { style } = props;

  const tournament = useTournament()

  const navigate = useGolfstatusNavigate();

  const titleSection = {
    gap: "medium-large-gap",
    sectionItems: [
      {
        type: "headline-2",
        value: tournament?.numberOfPlayers === 1 ? "Player Registration" : "Team & Player Registration",
      },
      {
        type: "secondary",
        value: `Check out all available registration packages for ${tournament.name}!`,
      },
    ],
  };

  const actionSection = {
    sectionItems: [
      {
        type: "mobile-stretch",
        value: (
          <GSButton
            style={{ flexGrow: 1 }}
            title="View Packages"
            rightIcon={faArrowRight}
            type="black"
            onClick={() => {
              navigate(
                getRouting(eventBaseRoute, [
                  tournament?.publicUrl,
                  "packages?view=team&view=player",
                ])
              );
            }}
          />
        ),
      },
    ],
  };

  const titleColumn = {
    fit: "stretch",
    sections: [titleSection],
  };

  const actionColumn = {
    type: "mobile-stretch",
    sections: [actionSection],
  };

  const columns = [titleColumn, actionColumn];

  return (
    <GSInfoGroup
      listType="mobile-vertical"
      style={style}
      dataGroups={columns}
    />
  );
};

export default RegisterNowWidget;
